export type FilterType = 'InvestmentOpportunities' | 'Plots' | 'SpacesForRent';

export interface FilterConfig {
    key: string;
    label: string;
    type: 'dropdown' | 'range' | 'text' | 'toggle';
    options?: Map<number, string>;
    placeholder?: string;
    tooltip?: string;
    listType?: 'checkbox' | 'single';
}

export interface RangeFilterConfig extends FilterConfig {
    minKey: string;
    maxKey: string;
}

export const getFilterConfigs = (filterType: FilterType, additionalData: any): FilterConfig[] => {
    const configs: Record<FilterType, FilterConfig[]> = {
        InvestmentOpportunities: [
            {
                key: 'landUses',
                label: 'get-filter-configs.landUse.label',
                type: 'dropdown',
                options: additionalData.landUseOptions || [],
                placeholder: 'get-filter-configs.landUse.placeholder',
                tooltip: 'get-filter-configs.landUse.tooltip',
                listType: 'checkbox'
            },
            {
                key: 'landArea',
                label: 'get-filter-configs.landArea.label',
                type: 'range',
                minKey: 'minArea',
                maxKey: 'maxArea'
            } as RangeFilterConfig,
            {
                key: 'city',
                label: 'get-filter-configs.city.label',
                type: 'dropdown',
                options: additionalData.cities || [],
                placeholder: 'get-filter-configs.city.placeholder',
                tooltip: 'get-filter-configs.city.tooltip'
            },
            {
                key: 'estimatedRate',
                label: 'get-filter-configs.estimatedRate.label',
                type: 'range',
                tooltip: 'get-filter-configs.estimatedRate.tooltip',
                minKey: 'minRate',
                maxKey: 'maxRate'
            } as RangeFilterConfig,
            {
                key: 'plotNumber',
                label: 'get-filter-configs.plotNumber.label',
                type: 'text',
                placeholder: 'get-filter-configs.plotNumber.placeholder',
                tooltip: 'get-filter-configs.plotNumber.tooltip'
            },
            {
                key: 'vacant',
                label: 'get-filter-configs.vacant.label',
                type: 'toggle'
            }
        ],
        Plots: [
            {
                key: 'landUses',
                label: 'get-filter-configs.landUse.label',
                type: 'dropdown',
                options: additionalData.landUseOptions || [],
                placeholder: 'get-filter-configs.landUse.placeholder',
                tooltip: 'get-filter-configs.landUse.tooltip',
                listType: 'checkbox'
            },
            {
                key: 'landArea',
                label: 'get-filter-configs.landArea.label',
                type: 'range',
                minKey: 'minArea',
                maxKey: 'maxArea'
            } as RangeFilterConfig,
            {
                key: 'city',
                label: 'get-filter-configs.city.label',
                type: 'dropdown',
                options: additionalData.cities || [],
                placeholder: 'get-filter-configs.city.placeholder',
                tooltip: 'get-filter-configs.city.tooltip'
            },
            {
                key: 'estimatedRate',
                label: 'get-filter-configs.estimatedRate.label',
                type: 'range',
                tooltip: 'get-filter-configs.estimatedRate.tooltip',
                minKey: 'minRate',
                maxKey: 'maxRate'
            } as RangeFilterConfig,
            {
                key: 'plotNumber',
                label: 'get-filter-configs.plotNumber.label',
                type: 'text',
                placeholder: 'get-filter-configs.plotNumber.placeholder',
                tooltip: 'get-filter-configs.plotNumber.tooltip'
            },
            {
                key: 'vacant',
                label: 'get-filter-configs.vacant.label',
                type: 'toggle'
            }
        ],
        SpacesForRent: [
            {
                key: 'floors',
                label: 'get-filter-configs.floors.label',
                type: 'dropdown',
                options: additionalData.floors || [],
                placeholder: 'get-filter-configs.floors.placeholder',
                listType: 'checkbox'
            },
            {
                key: 'landArea',
                label: 'get-filter-configs.spaceArea.label',
                type: 'range',
                minKey: 'minArea',
                maxKey: 'maxArea'
            } as RangeFilterConfig,
            {
                key: 'city',
                label: 'get-filter-configs.spaceCity.label',
                type: 'dropdown',
                options: additionalData.citiesEn || [],
                placeholder: 'get-filter-configs.spaceCity.placeholder',
                tooltip: 'get-filter-configs.spaceCity.tooltip'
            },
            {
                key: 'estimatedRate',
                label: 'get-filter-configs.spaceRate.label',
                type: 'range',
                tooltip: 'get-filter-configs.spaceRate.tooltip',
                minKey: 'minRate',
                maxKey: 'maxRate'
            } as RangeFilterConfig,
            {
                key: 'officeNumber',
                label: 'get-filter-configs.officeNumber.label',
                type: 'text',
                placeholder: 'get-filter-configs.officeNumber.placeholder',
                tooltip: 'get-filter-configs.officeNumber.tooltip'
            }
        ]
    };
    return configs[filterType];
};
